<template>
  <tooltip
    :content="tooltipContent()"
    class="d-flex justify-content-center align-items-center text-center"
    :class="avatarClass"
    :style="randombg ? randomBgColor : ''"
  >
    <span class="initials text-white align-self-center"
      >{{ $filters.first(firstname) }}{{ $filters.first(lastname) }}</span
    >
  </tooltip>
</template>

<script>
import Tooltip from '@/components/Tooltip.vue'

import { stringToHslColor } from '../utilities/helpers'

export default {
  components: {
    Tooltip
  },
  props: {
    tooltip: {
      required: false,
      default: false
    },
    shape: {
      required: false,
      default: 'circle'
    },
    firstname: {
      required: true,
      validator: prop => typeof prop === 'string' || prop === null
    },
    lastname: {
      required: true,
      validator: prop => typeof prop === 'string' || prop === null
    },
    background: {
      type: String,
      default: 'bg-primary'
    },
    randombg: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    randomBgColor() {
      return 'background-color: ' + stringToHslColor(this.firstname + ' ' + this.lastname, 30, 50)
    },
    avatarClass() {
      let className = this.shape === 'circle' ? 'rounded-circle' : 'rounded'
      if (!this.randombg) {
        className += ' bg-primary'
      }
      return className
    }
  },
  methods: {
    tooltipContent() {
      if (this.tooltip) {
        return this.firstname + ' ' + this.lastname
      }
      return null
    }
  }
}
</script>

<style lang="scss" scoped>
.avatar-circle {
  width: 100px;
  height: 100px;
}

.avatar-square {
  width: 100px;
  height: 100px;
}

.initials {
  position: relative;
  font-size: 50px; /* 50% of parent */
  line-height: 50px; /* 50% of parent */
}

body[data-leftbar-theme='dark'] {
  .rounded-circle,
  .rounded-square {
    background-color: $secondary !important;
    color: $gray-200 !important;
  }
}

@mixin avatar-circle($size) {
  width: $size;
  height: $size;

  .initials {
    position: relative;
    font-size: $size * 0.5;
    line-height: $size * 0.5;
  }
}

@mixin avatar-square($size) {
  width: $size;
  height: $size;
  border-radius: $size * 0.2 !important;

  .initials {
    position: relative;
    font-size: $size * 0.4;
    line-height: $size * 0.4;
  }
}

.avatar-circle {
  @include avatar-circle(100px);
}
.avatar-circle-sm {
  @include avatar-circle(32px);
}
.avatar-circle-lg {
  @include avatar-circle(250px);
}

.avatar-square {
  @include avatar-square(100px);
}
.avatar-square-sm {
  @include avatar-square(40px);
}
.avatar-square-lg {
  @include avatar-square(250px);
}

.farmer-detail {
  .initials {
    font-size: 48px;
    font-weight: 600;
  }
}
</style>
